<script setup lang="ts">
interface Props {
  modelValue?: boolean
  label?: string
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  label: '',
  disabled: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.checked)
}
</script>

<template>
  <label class="flex items-center space-x-2">
    <input
      type="checkbox"
      :checked="modelValue"
      :disabled="disabled"
      class="rounded border-gray-300 text-primary-500 focus:ring-primary-500"
      @change="handleChange"
    />
    <span v-if="label" class="text-sm text-gray-700">{{ label }}</span>
  </label>
</template>
